import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { Button } from "react-bootstrap";
import { React, useCallback } from "react";
import FileSaver from "file-saver";
import { useCurrentPng } from "recharts-to-png";

const DualAxesChart = ( { allData }) => {
  // data pre process
  const [ url, data ] = allData;
  const myData = Array.from(data.image);

  const [getPng, { ref, isLoading }] = useCurrentPng();
  const handleDownload = useCallback(async () => {
    const png = await getPng();
    // Verify that png is not undefined
    if (png) {
      // Download with FileSaver
      FileSaver.saveAs(png, url+'.png');
    }
  }, [getPng]);
  const chartWidth = 621;
  const chartHeight = 235;
  // 获取数据数组的最后一个元素
  const lastDataPoint = myData[myData.length - 1];
  // 定义一个自定义的 Tooltip Content 组件
  const CustomTooltipContent = () => {
    return (
      <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: '8px', borderRadius: '4px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
        <p style={{ margin: 0, fontWeight: 'bold' }}>Date: {lastDataPoint.date}</p>
        <p style={{ margin: 0 }}>Organic Traffic: {lastDataPoint.OrganicTraffic}</p>
        <p style={{ margin: 0 }}>Organic Pages: {lastDataPoint.OrganicPages}</p>
      </div>
    );
  };

  // If the data is a string, it represents non target JSON data
  if (typeof data.image === "string") {
    return <strong>Loading...</strong>;
  }

  return (
    <>
      <LineChart width={chartWidth} height={235} data={myData} ref={ref}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis yAxisId='left' domain={['auto', 'auto']} />
        <YAxis yAxisId='right' orientation='right' domain={['auto', 'auto']} />
        <Line yAxisId='left' type="monotone" dataKey="OrganicTraffic" stroke="#8884d8" dot={false} activeDot={{ r: 8 }} name="Organic Traffic" />
        <Line yAxisId='right' type="monotone" dataKey="OrganicPages" stroke="#82ca9d" dot={false} activeDot={{ r: 8 }} name="Organic Pages" />.
        {/* <Tooltip active={true} cursor={true}  content={<CustomTooltipContent  />}/>  */}
        {/* <Tooltip active={true} cursor={true}  payload={lastDataPoint}/>  */}
        <Tooltip 
          active={true} 
          cursor={true} 
          content={<CustomTooltipContent />} // 使用自定义的 Tooltip Content
          position={{ x: chartWidth - 230, y: chartHeight - 160 }} // 设置位置在图表的右下角
          contentStyleObject={{ background: '#fff', border: '1px solid #ccc', borderRadius: '5px' }}
          labelStyleObject={{ color: '#333', marginBottom: '5px' }}
        />
        {/* <Tooltip /> */}
        <Legend />
      </LineChart>
      <br/>
      <Button onClick={handleDownload}>
        {isLoading ? 'Downloading...' : 'Download Chart'}
      </Button>
    </>
  );
};

export default DualAxesChart;
